export function boundingBoxContainsPoint(boundingBox, point) {
    const [minLon, minLat, maxLon, maxLat] = boundingBox;
    const [lon, lat] = point;
    return lat >= minLat && lat <= maxLat && lon >= minLon && lon <= maxLon;
}
export function mapboxToInternalBounds(bounds) {
    return [
        bounds.getWest(),
        bounds.getSouth(),
        bounds.getEast(),
        bounds.getNorth(),
    ];
}
export function mapboxRNToInternalBounds(
//Mapbox RN provides bounds as [NE, SW]
bounds) {
    return [
        bounds[1][0],
        bounds[1][1],
        bounds[0][0],
        bounds[0][1],
    ];
}
export function mapboxGeoJSONToInternalBounds(bounds) {
    return [
        bounds.sw[0],
        bounds.sw[1],
        bounds.ne[0],
        bounds.ne[1],
    ];
}
//# sourceMappingURL=bounding-box.js.map